import get from 'lodash/get';

const initialState = { businesses: [], totalPages: 1, page: 1 };

export function agentBusinesses(state = initialState, action) {
  const foundByUUID = state?.businesses?.findIndex(
    business => business.uuid === action?.res?.data?.uuid,
  );

  const businesses = get(state, 'businesses') || [];
  switch (action.type) {
    case 'GET_AGENT_BUSINESSES': {
      const { businesses, totalPages, page } = action.res.data;
      return {
        ...state,
        businesses,
        totalPages,
        page,
      };
    }

    case 'QUALIFY_PROSPECT_AS_OPPORTUNITY':
    case 'CLOSE_OPPORTUNITY':
    case 'CLOSE_ALL_PRODUCTS':
    case 'CLOSE_PROSPECT':
      if (foundByUUID >= 0) {
        return {
          ...state,
          businesses: [
            ...businesses.slice(0, foundByUUID),
            ...businesses.slice(foundByUUID + 1),
          ],
        };
      }
      return state;
    case 'CLOSE_PRODUCTS':
      return {
        ...state,
        businesses: [
          ...businesses.slice(0, foundByUUID),
          action.res.data,
          ...businesses.slice(foundByUUID + 1),
        ],
      };
    default:
      return state;
  }
}
